<template>
  <div>
    <idf-component-link class="p-article-thumbnail-highlighted_main_xxl" :url="article.url" data-test-article-main>
      <adn-image
        class="p-article-thumbnail-highlighted_main_xxl__backgroundImage"
        :source="article.backgroundImage"
        alt=""
      />
      <div class="p-article-thumbnail-highlighted_main_xxl_buttons">
        <p-component-tag class="p-article-thumbnail-highlighted_main_tags" :tag="article.tags" />
        <h2 class="p-article-thumbnail-highlighted_main_title">{{ article.title }}</h2>
        <adn-button kind="secondary" class="p-article-thumbnail-highlighted_main_item" markup="span">
          <idf-component-link :url="article.url">{{ article.buttonLabel }}</idf-component-link>
        </adn-button>
      </div>
    </idf-component-link>
    <idf-component-link
      class="p-article-thumbnail-highlighted_main_md"
      :url="article.url"
      :style="`background-image: url(${optimizeImage(article.backgroundImage)})`"
    >
      <div class="p-article-thumbnail-highlighted_main_md_buttons">
        <p-component-tag class="p-article-thumbnail-highlighted_main_md_tags" :tag="article.tags" />
        <h2 class="p-article-thumbnail-highlighted_main_title">{{ article.title }}</h2>
      </div>
    </idf-component-link>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IdfComponentLink from '@b2ag/design-system/src/components/IdfComponentLink/IdfComponentLink.vue'
import PComponentTag from '@b2ag/marketing/src/application/presenters/PComponentTag/PComponentTag.vue'
import AdnButton from '@b2ag/design-system/src/components/AdnButton/AdnButton.vue'
import AdnImage from '@b2ag/design-system/src/components/AdnImage/AdnImage.vue'
import { getConfig } from '@b2ag/micro-front-tools'

export default defineComponent({
  name: 'PArticleThumbnailHighlighted',
  components: { IdfComponentLink, PComponentTag, AdnButton, AdnImage },
  props: {
    article: {
      default: () => ({}),
      type: Object,
    },
  },
  setup() {
    function optimizeImage(url) {
      return `https://res.cloudinary.com/${getConfig('CLOUDINARY_BUCKET_NAME')}/image/fetch/q_auto,f_auto,c_pad/${url}`
    }

    return {
      optimizeImage,
    }
  },
})
</script>

<style scoped lang="scss">
.p-article-thumbnail-highlighted_main_xxl {
  margin: var(--spacing-2) 0;
  border: 1px solid transparent;
  box-shadow: -0.2rem 0.2rem var(--spacing-2) rgb(87 94 98 / 20%);
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius-3);

  @media (max-width: $breakpoint-md) {
    display: none;
  }

  &:hover {
    border-color: var(--color-blue);
    box-shadow: var(--shadow-dark);
  }
}

.p-article-thumbnail-highlighted_main_xxl__backgroundImage {
  border-radius: inherit;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.p-article-thumbnail-highlighted_main_xxl_buttons {
  bottom: 0;
  position: absolute;
  height: auto;
  width: auto;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  padding: var(--spacing-4);
}

.p-article-thumbnail-highlighted_main_tags {
  --tagTextColor: #{var(--color-success-hover)};
  --tagMargin: 0;
  --tagPadding: 0.2rem #{var(--spacing-2)};
  --tagTextColor: unset;

  margin-bottom: var(--spacing-3);

  @media (max-width: $breakpoint-md) {
    margin-bottom: 0;
  }
}

.p-article-thumbnail-highlighted_main_title {
  margin-bottom: var(--spacing-3);
  font-weight: bold;
  font-size: var(--article-thumbnail-highlighted-font-size, #{var(--font-size-xxl)});
  line-height: var(--line-height-xl);
  color: var(--color-background-light);

  @media (max-width: $breakpoint-md) {
    margin-bottom: 0;
  }

  @media (max-width: $breakpoint-md) {
    font-size: var(--font-size-l);
  }
}

.p-article-thumbnail-highlighted_main_item {
  width: fit-content;

  @media (max-width: $breakpoint-md) {
    display: none;
  }
}

.p-article-thumbnail-highlighted_main_md {
  margin: var(--spacing-2) 0;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  border-radius: var(--border-radius-3);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;

  @media (min-width: $breakpoint-md + 1) {
    display: none;
  }
}

.p-article-thumbnail-highlighted_main_md_buttons {
  width: 100%;
  background-color: var(--color_background-light);
  border-radius: 0 0 var(--border-radius-3) var(--border-radius-3);
  display: flex;
  flex-direction: column;
  padding: var(--spacing-3);
}

.p-article-thumbnail-highlighted_main_md_tags {
  --tagTextColor: var(--color-main);
  --tagBackgroundColor: var(--color-background);
  --tagMargin: 0 0 0 0;
}
</style>
